module.exports = __webpack_public_path__ + "static/media/pic_6_26.c5467ae5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pic_6_26.jpg
// module id = 1839
// module chunks = 0 1